var _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "globalnav-menutrigger-bread-bottom",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2 12, 16 12",
    className: "globalnav-menutrigger-bread globalnav-menutrigger-bread-bottom"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "globalnav-anim-menutrigger-bread-bottom-open",
    attributeName: "points",
    keyTimes: "0;0.5;1",
    dur: "0.24s",
    begin: "indefinite",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.42, 0, 1, 1;0, 0, 0.58, 1",
    values: " 2 12, 16 12; 2 9, 16 9; 3.5 15, 15 3.5"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "globalnav-anim-menutrigger-bread-bottom-close",
    attributeName: "points",
    keyTimes: "0;0.5;1",
    dur: "0.24s",
    begin: "indefinite",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.42, 0, 1, 1;0, 0, 0.58, 1",
    values: " 3.5 15, 15 3.5; 2 9, 16 9; 2 12, 16 12"
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "globalnav-menutrigger-bread-top",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2 5, 16 5",
    className: "globalnav-menutrigger-bread globalnav-menutrigger-bread-top"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "globalnav-anim-menutrigger-bread-top-open",
    attributeName: "points",
    keyTimes: "0;0.5;1",
    dur: "0.24s",
    begin: "indefinite",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.42, 0, 1, 1;0, 0, 0.58, 1",
    values: " 2 5, 16 5; 2 9, 16 9; 3.5 3.5, 15 15"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "globalnav-anim-menutrigger-bread-top-close",
    attributeName: "points",
    keyTimes: "0;0.5;1",
    dur: "0.24s",
    begin: "indefinite",
    fill: "freeze",
    calcMode: "spline",
    keySplines: "0.42, 0, 1, 1;0, 0, 0.58, 1",
    values: " 3.5 3.5, 15 15; 2 9, 16 9; 2 5, 16 5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.14888a835d16b7870b9db8742f933d21.svg";
export { ForwardRef as ReactComponent };